import React from 'react';
import { useTranslation } from 'react-i18next';
import Devices from '../../../../../../public/emptystates/DispositivosEmptystate.svg'

const EmptyDevices = () => {
  const { t } = useTranslation(['myDevices']);
  return (
    <div className="Services__FlexContent">
      <div className="Profile__FlexItem-NoPadding">
        <div className="Services__ContentES">
          <img src={Devices} alt='no devices' />
        </div>
        <div className="ProfileForm__EmptyState">
          <p className="ProfileForm__EmptyStateTitle">
            {t('deviceTitle')}
          </p>
          <p className="ProfileForm__EmptyStateSubtitle">
            {t('addADevice')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyDevices;
